/*
 * Before/After wipe — progressive enhancement only.
 *
 * Without this file every frame stays at the CSS default of 50% and still shows a true
 * half-and-half comparison (`--ba-pos` in editorial.css), so nothing here is load-bearing for
 * correctness. It only makes the split draggable.
 *
 * Shared by the product page and the LP showcase. It wires every `.ba__range` on the page
 * rather than a section's own subtree, so a section can render the figure snippet without
 * carrying its own copy of this behaviour.
 */
(function () {
  var wire = function (range) {
    if (range.dataset.baWired === '1') return;
    var frame = range.closest('.ba__frame');
    if (!frame) return;
    range.dataset.baWired = '1';

    var apply = function () {
      frame.style.setProperty('--ba-pos', range.value + '%');
    };

    // `input` covers drag, click and keyboard on every current browser.
    range.addEventListener('input', apply);
    apply();
  };

  var wireAll = function () {
    document.querySelectorAll('.ba__range').forEach(wire);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }

  // The theme editor re-renders a section's markup in place without reloading the page, which
  // would otherwise leave the new inputs unwired and the wipe frozen at 50% while editing.
  document.addEventListener('shopify:section:load', wireAll);
})();
